import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

/**
 * The retired file-checklist portal.
 *
 * This used to be a second public page onto the same checklist the project
 * dashboard already embeds — two links to one list, and no way for a client to
 * know which was current. It also carried the file-upload path, which wrote to
 * storage nobody in the studio could read back.
 *
 * The page is gone, but its links are sitting in clients' inboxes, so the token
 * still has to land somewhere useful: resolve it to the project's dashboard
 * link and go there. A token that resolves to nothing says so plainly instead
 * of showing a broken shell.
 */
export default function VexosClientPortal() {
  const { token } = useParams();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await axios.get(`${API}/project-tracker/client/by-checklist-token/${token}`);
        if (!alive) return;
        // replace(), not assign(): Back should return the client to wherever
        // they came from, not to a page that immediately redirects again.
        window.location.replace(`/track/${res.data.token}`);
      } catch {
        if (alive) setFailed(true);
      }
    })();
    return () => { alive = false; };
  }, [token]);

  return (
    <div className="min-h-screen bg-canvas flex items-center justify-center px-6">
      {failed ? (
        <div className="text-center" style={{ maxWidth: "46ch" }}>
          <p style={{ fontSize: 21, fontWeight: 300, color: "var(--ink)", letterSpacing: "-0.6px" }}>
            This link has been replaced
          </p>
          <p className="body-text" style={{ marginTop: 10, color: "var(--tertiary)" }}>
            Your project now lives on a single dashboard link. Ask your project lead to send it
            over — it covers your file list, your deliveries and your documents in one place.
          </p>
        </div>
      ) : (
        <Loader2 className="w-6 h-6 animate-spin" strokeWidth={1.5} style={{ color: "var(--quiet)" }} />
      )}
    </div>
  );
}
